import React from 'react';
export const Banner32DataSource = {
  wrapper: { className: 'banner3' },
  textWrapper: {
    className: 'banner3-text-wrapper',
    children: [
      {
        name: 'nameEn',
        className: 'banner3-name-en l5m2vfpnx5h-editor_css',
        children: (
          <span>
            {/* <p>Seeking Experience &amp; Keep you in my heart</p> */}
          </span>
        ),
      },
      {
        name: 'slogan',
        className: 'banner3-slogan l5m2tw7orq9-editor_css',
        children: '针对不同行业属性及规模',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner3-name',
        children: (
          <span>
            <span>
              <span>
                <p>制定了专业的行业解决方案</p>
              </span>
            </span>
          </span>
        ),
      },
      {
        name: 'button',
        className: 'banner3-button l5m2ukn6ge-editor_css',
        children: (
          <span>
            <p>解决方案</p>
          </span>
        ),
      },
      {
        name: 'time',
        className: 'banner3-time',
        children: (
          <span>
            <span>
              <p>@江西融云网络科技有限公司</p>
            </span>
          </span>
        ),
      },
    ],
  },
};
export const Feature00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5qfo1xi9y-editor_css',
  },
  page: { className: 'home-page content0 l5qh0rufdkj-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>解决方案</p>
          </span>
        ),
      },
      {
        name: 'content~l5qfrnnwvne',
        className: '',
        children: (
          <span>
            <p>Solution</p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qg484xrn-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon l5qgyc16sxb-editor_css',
              children:
                'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/8f687a7f-5a0a-48d0-9972-1db74e94f251.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <p>教育行业</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    通过信息化手段，将学校管理过程优化协调，实现校园内各类资源的有效集成、整合，提高教育软硬件设备的配置和利用率，构建智慧物联的数字校园。
                  </p>
                </span>
              ),
              className: 'l5qfjxh4lw-editor_css',
            },
            {
              name: 'button~l5qfjztx3p',
              className: 'l5qg7pk676i-editor_css',
              children: {
                children: (
                  <span>
                    <p>了解详情</p>
                  </span>
                ),
                href: '/solution-list?name=教育行业&type=jrhy',
                type: 'default',
              },
            },
          ],
        },
      },
      {
        name: 'block~l5qfl3okjvq',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qg4gro7xe-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon l5qgyhrz5ip-editor_css',
              children:
                'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/44582821-f477-4756-9e56-8d4aca50e21d.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>政府行业</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>
                      充分利用物联网、云计算、大数据分析、移动互联网等新一代信息技术，以用户创新、大众创新、开放创新、共同创新为特征，强调作为平台的政府架构，并以此...
                    </p>
                  </span>
                </span>
              ),
              className: 'l5qfjxh4lw-editor_css',
            },
            {
              name: 'button~l5qfjztx3p',
              className: '',
              children: {
                children: (
                  <span>
                    <p>了解详情</p>
                  </span>
                ),
                href: '/solution-list?name=政府行业&type=zfhy',
                type: 'default',
                className: 'l5qg8i3grmh-editor_css',
              },
            },
          ],
        },
      },
      {
        name: 'block~l5qfl4dwko7',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qg4kw4r8-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon l5qgyx0fjv-editor_css',
              children:
                'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/66fbe35b-c1df-4aad-93fb-837b976c9319.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <p>服务行业</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>
                      通过打造健康档案区域医疗信息平台，利用最先进的物联网技术，实现患者与医务人员、医疗机构、医疗设备之间的互动，逐步达到信息化。
                    </p>
                  </span>
                </span>
              ),
              className: 'l5qfjxh4lw-editor_css',
            },
            {
              name: 'button~l5qfjztx3p',
              className: '',
              children: {
                children: (
                  <span>
                    <p>了解详情</p>
                  </span>
                ),
                href: '/solution-list?name=服务行业&type=fwhy',
                type: 'default',
                className: 'l5qg8aechk-editor_css',
              },
            },
          ],
        },
      },
      {
        name: 'block~l5qfl5gszi',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item l5qg4uaipoj-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon l5qgz4r2mw-editor_css',
              children:
                'https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/a2dc72f0-2eb5-475c-a0be-6ea6dc49febd.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: (
                <span>
                  <span>
                    <p>企业行业</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <span>
                    <p>
                      主动顺应互联网时代公共法律服务的更高要求，持续推动云计算、大数据、人工智能等现代信息技术手段与法律服务工作的高度融合，有机加强资源整合、流程...
                    </p>
                  </span>
                </span>
              ),
              className: 'l5qfjxh4lw-editor_css',
            },
            {
              name: 'button~l5qfjztx3p',
              className: '',
              children: {
                children: (
                  <span>
                    <p>了解详情</p>
                  </span>
                ),
                href: '/solution-list?name=企业行业&type=qyhy',
                type: 'default',
                className: 'l5qg8mhvo6r-editor_css',
              },
            },
          ],
        },
      },
    ],
  },
};
export const Feature01DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper l5qg3lregzm-editor_css',
  },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>
              <br />
            </p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper l5qh11t7h2-editor_css',
    children: [
      {
        name: 'block0',
        className: 'content0-block l5qg3i1awx-editor_css',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children:
                'https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png',
            },
            {
              name: 'title',
              className: 'content0-block-title',
              children: '一站式业务接入',
            },
            { name: 'content', children: '支付、结算、核算接入产品效率翻四倍' },
          ],
        },
      },
    ],
  },
};
